import React from 'react';
import { Link } from 'react-router-dom';

/**
 * A member's name or email that opens their User 360 page (`/user-detail/:encodedUserId`).
 *
 * Rows without a known member id (blank `userId`) render the text alone — there is nowhere to
 * go. Empty text renders `fallback`, never a link with nothing to click.
 *
 * Props: { userId, children, fallback = '-', className, testId = 'user-detail-link' }
 */
export const userDetailPath = (userId) => `/user-detail/${btoa(String(userId))}`;

const UserDetailLink = ({ userId, children, fallback = '-', className = '', testId = 'user-detail-link' }) => {
  const empty = children === null || children === undefined || children === '';
  if (empty) return <>{fallback}</>;
  const hasId = userId !== null && userId !== undefined && String(userId).trim() !== '';
  if (!hasId) return <>{children}</>;
  return (
    <Link
      className={`au-link ${className}`.trim()}
      to={userDetailPath(String(userId).trim())}
      title="Open user details"
      data-testid={testId}
    >
      {children}
    </Link>
  );
};

export default UserDetailLink;
